<h1 mat-dialog-title>{{ 'report.generateReportTitle' | transloco }}</h1>

<mat-dialog-content>
  <div *ngIf="callerLevel === packagingPartEnum.Unit || callerLevel === packagingPartEnum.System">
    <mat-form-field class="full-width">
      <mat-label>{{ 'report.reportCountries' | transloco }}</mat-label>
      <mat-select [formControl]="selectedReportCountries" multiple>
        <mat-option *ngFor="let country of relevantCountries" [value]="country">{{country.name}}</mat-option>
      </mat-select>
      <mat-error *ngIf="selectedReportCountries.errors">
        <span *ngIf="selectedReportCountries.errors.required">
          {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
        </span>
      </mat-error>
    </mat-form-field>
  </div>

  <mat-form-field class="full-width">
    <mat-label>{{ 'report.reportName' | transloco }}</mat-label>
    <input matInput [formControl]="reportName">
  </mat-form-field>

  <div *ngIf="reportTemplates.length > 0">
    <p>{{ 'report.reportTemplate' | transloco }}</p>
    <div id="template-selection">
      <app-report-templates-overview [reportTemplates]="reportTemplates" [displayedColumns]="displayedColumns"
        [canSelectRows]="true" (selectedTemplateChange)="setSelectedReportTemplate($event)">
      </app-report-templates-overview>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="generateReport()" type="submit">
    {{ 'common.buttons.ok' | transloco }}
  </button>
  <button mat-raised-button (click)="cancel()" type="button">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
</mat-dialog-actions>
